import Listar from '@/views/CreditoDebito/Listar'
import Form from '@/views/CreditoDebito/Form'

const routes = [
    {
        meta: {auth: true},
        path: '/creditoDebito',
        name: 'creditoDebito',
        component: Listar
    },

    {
        meta: {auth: true},
        path: '/creditoDebito/adicionar',
        name: 'creditoDebito.adicionar',
        component: Form
    },

    {
        meta: {auth: true},
        path: '/creditoDebito/editar/:id',
        name: 'creditoDebito.editar',
        component: Form
    },
]
export default routes
